import { RootDispatch, RootGetState, Page } from "../types";
import { get } from "../../utils/fetch";
import { cleanPatientResponse, Patient, PatientResponse } from "../patient/types";

export type Action =
  | { type: "dashboard/setSearchString"; searchString: string }
  | { type: "dashboard/setInactive"; showInactive: boolean }
  | { type: "dashboard/getPatientList-started" }
  | {
      type: "dashboard/getPatientList-success";
      patientList: Page<Patient>;
    }
  | { type: "dashboard/getPatientList-failure" }
  | { type: "dashboard/getMorePatients-started" }
  | { type: "dashboard/getMorePatients-success"; patientList: Page<Patient> }
  | { type: "dashboard/getMorePatients-failure" }
  | { type: "dashboard/removePatientFromList"; patient: Patient }
  | { type: "dashboard/getLocations-started" }
  | { type: "dashboard/getLocations-success"; locations: string[] }
  | { type: "dashboard/getLocations-failure" }
  | { type: "dashboard/setLocation"; selectedLocation: string };

export const setSearchString = (searchString: string) => async (dispatch: RootDispatch) => {
  dispatch({
    type: "dashboard/setSearchString",
    searchString: searchString
  });
};

export const setShowInactive = (showInactive: boolean) => async (dispatch: RootDispatch) => {
  dispatch({
    type: "dashboard/setInactive",
    showInactive: showInactive
  });
};

export const setLocation = (selectedLocation: string) => async (dispatch: RootDispatch) => {
  dispatch({
    type: "dashboard/setLocation",
    selectedLocation: selectedLocation
  });
};

export const getPatientList = () => async (dispatch: RootDispatch, getState: RootGetState) => {
  dispatch({
    type: "dashboard/getPatientList-started"
  });

  const url =
    "/api/organization/" +
    getState().orgs.currentOrganization?.id +
    "/patients/?isActive=" +
    encodeURIComponent(!getState().dashboard.data.showInactive) +
    "&search=" +
    encodeURIComponent(getState().dashboard.data.searchString) +
    "&location=" +
    encodeURIComponent(getState().dashboard.data.selectedLocation);

  const resp = await get<Page<PatientResponse>>(url);

  if (resp.error) {
    dispatch({ type: "dashboard/getPatientList-failure", error: resp.error.message });
  } else if (resp.data) {
    dispatch({
      type: "dashboard/getPatientList-success",
      patientList: { ...resp.data, results: resp.data.results.map(p => cleanPatientResponse(p)) }
    });
  } else {
    // TODO Logging
  }
};

export const getMorePatients = () => async (dispatch: RootDispatch, getState: RootGetState) => {
  dispatch({
    type: "dashboard/getMorePatients-started"
  });

  const resp = await get<Page<PatientResponse>>(getState().dashboard.data.patientList.next);

  if (resp.error) {
    dispatch({
      type: "dashboard/getMorePatients-failure",
      error: resp.error.message
    });
  } else if (resp.data) {
    dispatch({
      type: "dashboard/getMorePatients-success",
      patientList: { ...resp.data, results: resp.data.results.map(p => cleanPatientResponse(p)) }
    });
  }
};

export const getLocations = (showInactive = false) => async (
  dispatch: RootDispatch,
  getState: RootGetState
) => {
  dispatch({
    type: "dashboard/getLocations-started"
  });

  const url =
    "/api/organization/" +
    getState().orgs.currentOrganization?.id +
    "/patients/locations/?showInactive=" +
    showInactive;

  const resp = await get<{ locations: string[] }>(url);

  if (resp.error) {
    dispatch({
      type: "dashboard/getLocations-failure",
      error: resp.error.message
    });
  } else if (resp.data) {
    dispatch({
      type: "dashboard/getLocations-success",
      locations: resp.data.locations
    });
  }
};
